module.exports = __webpack_public_path__ + "assets/select-arrow.d0e8b532.svg";